const QR_ROUTE_PREFIXES = ['/qr/', '/building-qr/'];

const QR_API_PATH_SEGMENT = '/api/qr/';

export function isQrRoutePath(url: string): boolean {
  const path = url.split(/[?#]/)[0];
  return QR_ROUTE_PREFIXES.some(prefix => path.startsWith(prefix));
}

export function isQrApiUrl(url: string): boolean {
  return url.includes(QR_API_PATH_SEGMENT);
}
